export const getWidthStyle = width => ({ width, minWidth: width, maxWidth: width });
